import { useEffect } from 'react'

// zmiana stepa nie zmienia wydajności
const step = 3

// let j = 0

const setWidth = (ref: React.RefObject<HTMLElement>) => {
  const el = ref.current

  if (!el) {
    return
  }

  const images = (el.innerHTML.match(/<img .{12}/g) || []).filter(
    img => img != '<img class="emoji'
  )

  if (
    el.innerText.length < 50 ||
    !el.innerText.includes(' ') ||
    images.length
  ) {
    return
  }

  el.style.removeProperty('width')

  const { offsetWidth: initW, offsetHeight: initH } = el

  for (let i = initW; i > 0; i = i - step) {
    el.style.width = i + 'px'

    if (el.offsetHeight > initH) {
      el.style.width = i + step + 'px'
      break
    }
  }
}

export function useNarrow(
  ref: React.RefObject<HTMLElement>,
  parentWidth: number
) {
  useEffect(() => {
    setTimeout(() => setWidth(ref))
    setTimeout(() => setWidth(ref), 100)
  }, [parentWidth])
}
